// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionCard-cls1_Ttf","cls2":"SuggestionCard-cls2_rQ4 SuggestionCard-cls1_Ttf"};